export const COST_STATISTICS_PAGE_UUID = '291f7a32-72b5-4048-8965-eb8c0f7e8948'
